import React from "react";
import { Link, Route } from "react-router-dom";
import { artemulkImages } from "../../data/artemulkContent";
import AboutUs from "../AboutUs/AboutUs";
import VisionMission from "./VisionMission";
import Back from "../common/Back";
import Call1 from "../Call1/Call1";
import Whatsapp1 from "../Whatsapp1/Whatsapp1";
import "./about.css";

const coverImg = artemulkImages.pageCover;

const About = () => {
  const ScrollToTop = () => {
    window.scrollTo(0, 0);
    return null;
  };

  return (
    <>
      <Route component={ScrollToTop} />
      <section className="about">
        <Back name="Arte Mülk" title="Hakkımızda" cover={coverImg} />
        <div className="pt-12 px-[3%] md:px-[6%]">
          <AboutUs />
          <VisionMission />

          <div className="my-12 p-8 rounded-2xl bg-gradient-to-r from-[#674921]/10 via-[#c5955b]/15 to-transparent border border-[#c5955b]/30 flex flex-col md:flex-row items-center justify-between gap-6 text-center md:text-left">
            <div>
              <span className="text-xs uppercase tracking-wider text-primary font-semibold">Ofislerimiz & Danışmanlarımız</span>
              <h3 className="text-2xl font-bold mt-1 text-[#674921] dark:text-white">Şubelerimizi & Ekibimizi Keşfedin</h3>
              <p className="text-muted text-sm mt-1 max-w-xl">
                İstanbul, İzmir, Balıkesir, Bandırma ve Bodrum şubelerimizdeki profesyonel danışman kadromuzla iletişime geçin.
              </p>
            </div>
            <Link
              to="/subelerimiz"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-primary hover:bg-[#674921] text-white font-medium shadow-md transition-colors duration-200 shrink-0"
            >
              Şubelerimiz & Ekibimiz →
            </Link>
          </div>
        </div>
        <Call1 />
        <Whatsapp1 />
      </section>
    </>
  );
};

export default About;
